"use client"
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';;
import Image from "next/image";
import { useEffect } from 'react';


const LearningSkill = () => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.init();
        }
    }, []);
    return (
        <section className="bg-[#F6F6F6] py-7 lg:py-14 md:py-14">
            <div className="container">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-[20px] lg:gap-[50px] md:gap-[30px]">
                    <div data-aos="fade-up" data-aos-duration="1000" className='order-2 lg:order-1'>
                        <div className="order-last md:order-first">
                            <h2 className="text-gray lg:text-[32px] md:text-[24px] text-[20px] font-semibold lg:mb-4 mb-4 leading-tight">ExC Academy: Your digital hub for skill growth and expertise!</h2>
                            <p className="text-[#000000] font-normal lg:text-[16px] text-[16px] mb-4">
                                At ExC Academy, we&apos;re at the forefront of building a digital-first ecosystem for learning skills. Our mission is to empower individuals to excel in the ever-evolving world of technology. Through a blend of innovation, cutting-edge Curriculum, and hands-on experience, we are shaping the future of technical education.
                            </p>
                            <div className="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 gap-1">
                                <div className="mb-3">
                                    <p className="text-[#000000] font-normal lg:text-[14px] text-[14px] mb-0">
                                        <span className="text-[#9014DC] font-bold">Our Partners</span> collaborations enable us to offer world-class training in technical areas, from SAP&apos;s ERP modules to the latest advancements in AI and blockchain.
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[#000000] font-normal lg:text-[14px] text-[14px] mb-0">
                                        <span className="text-[#9014DC] font-bold">Benefits</span> designed to provide students with the skills they need for a successful career in the IT sector. The experiential learning model bridges the gap between theoretical knowledge and practical application.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div data-aos="fade-up" data-aos-duration="1000" className='order-1 lg:order-2'>
                        <div className="overflow-hidden rounded-tl-[30px] rounded-br-[40px] h-[100%] order-first md:order-last">
                            <Image
                                height={600}
                                width={600} src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/about/building-the-digital-first-ecosystem.webp"
                                className="m-auto"
                                alt="ecosystem-img"
                                fetchPriority="high"
                                loading="eager"
                                rel="preload"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default LearningSkill;